import { Divider, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import React from 'react';
import styled from 'styled-components';
import FormikWorkflowButtonsControl from './FormikWorkflowButtonsControl';


const Container = styled.div`
    width:100%
    padding:20px;
    display:grid;
    grid-template-columns:50px 250px 300px 40px;
    align-items:center;
    padding-top:5px;
    
`;

const StepCount = styled.div`
    text-align: center;
    color: white;
    border-radius: 50%;
    height: 25px;
    line-height:25px;
    background: gray;
    width:25px;
`;

const StepCountContainer = styled.div`
    display:flex;
    align-items:center;
    align-content:center;
`;

const StepLabelContainer = styled.div`

`;

const Type = styled.div`

`;

const DeleteStep = styled.div`
    font-size:24px;
`;



const WorkflowStep = ({arrayHelpers,index,formProps}) => {

    const stepScopeTitleValues = [
        { title: 'Project', value: 'PROJECT' },
        { title: 'GBU', value: 'GBU' },
        { title: 'Corporate', value: 'CORP' },

    ];

    return (
                <>
                <Container  key={index}>
                     <StepCountContainer>
                         <StepCount>{index + 1}</StepCount>
                     </StepCountContainer>
                     <StepLabelContainer>
                     <Field name={`workflowSteps.${index}.stepLabel`} 
                            label={formProps.values.workflowSteps[index].stepLabel ? '' : 'Step Label'}
                            component={TextField}
                      />

                     </StepLabelContainer>
                     <Type>
                     <FormikWorkflowButtonsControl
                        pillStyling
                        buttonTitleValues={stepScopeTitleValues}
                        setFieldValue={formProps.setFieldValue}
                        setFieldTouched={formProps.setFieldTouched}
                        field={`workflowSteps.${index}.stepScope`}
                        value={formProps.values.workflowSteps[index].stepScope}
                        index={index}
                        formProps={formProps}
                    />                    
                     </Type>
                     <DeleteStep>
                     {(formProps.values.workflowSteps.length > 1 && formProps.values.workflowSteps.length -1 === index) &&
                         <IconButton size="medium" color="primary">
                            <DeleteIcon fontSize="inherit" onClick={() => arrayHelpers.remove(index)}/>
                         </IconButton>
                    }
                     </DeleteStep>
                     
                </Container>
                <div style={{paddingTop:1}}/>

                </>
                    
    )
}

export default WorkflowStep;